import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';

export const container = css({
  marginLeft: -14,
});

export const button = css({
  border: 0,
  backgroundColor: colorsPalette.transparent,
  color: colorsPalette.black,
  width: 48,
  height: 48,
  cursor: 'pointer',
});

export const icon = css({
  fontSize: 15,
});
